export default __webpack_public_path__ + "static/admin-tool-tip-e41c1705.svg";